import Link from 'next/link';

import Layout1x1 from 'components/Layout1x1';
import Line from 'components/Line';

const linksMap = {
  'blue-suit': (
    <Link href="/collection/tuxedos-and-suits?color=Blue&type=Suit" className="tracker-text-tuxedos_and_suits-blue_suit-230815-145337">
      {'blue suit'}
    </Link>
  ),
  'black-tux': (
    <Link href="/collection/tuxedos-and-suits?color=Black&type=Tux" className="tracker-text-tuxedos_and_suits-black_tuxedo-230815-145339">
      {'black tuxedo'}
    </Link>
  ),
};

const TuxedosAndSuitsCopy = () => (
  <Layout1x1>
    <h3 data-testid="title" className="text-h2">
      {'RENT SUITS & TUXEDOS ONLINE'}
    </h3>
    <Line className="!text-gray-dark" />
    <p data-testid="content" className="text-gray-darker">
      Available in Slim and Modern fits, and boys' sizes, all of our suits and tuxedos are made with Super 130's and 140's Merino Wool. Stay
      comfortable with our hidden Flex-fix waistband and flat front pants. Whether you are looking for a {linksMap['blue-suit']}, a tan suit
      or a traditional {linksMap['black-tux']}, feeling good and looking good has never been easier for grooms, groomsmen and wedding
      parties.
    </p>
  </Layout1x1>
);

export default TuxedosAndSuitsCopy;
